import React, { Component } from 'react';

const FacebookLogo = (props) => {
	return (
		<div class="facebook_logo">
			<svg width="30px" height="30px" viewBox="0 0 30 30">
				<path fill="#FFFFFF" d="M15,6c-4.97,0-9,4.03-9,9c0,4.43,3.21,8.11,7.43,8.85c0-1.63,0-4.2,0-6.13h-2.25v-2.58h2.25c0-0.6,0-1.05,0-1.25c0-2.01,0.28-2.81,1.39-3.62c0.83-0.61,2.15-0.61,4-0.45v2.39c0,0-1.21-0.03-1.74,0.02c-0.55,0.05-0.95,0.25-0.95,1.36c0,0.19,0,0.77,0,1.55h2.59l-0.33,2.58h-2.26c0,1.98,0,4.58,0,6.2C20.56,23.37,24,19.59,24,15C24,10.03,19.97,6,15,6z"/>
			</svg>
		</div>
	)
}

export default FacebookLogo;